import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8829f2f2"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("请在微信中打开");

const _hoisted_2 = {
  key: 1,
  class: "container"
};
import { ref } from 'vue';
import { useStore } from '@/store';
import { $getAppId } from '@/service';
import { useRouter } from 'vue-router';
export default {
  __name: 'Auth',

  setup(__props) {
    const store = useStore();
    const router = useRouter();
    let auth = ref(true);
    let code = '';
    const href = window.location.href;

    if (store.isWxBrowser()) {
      if (store.openId) {
        navigateTo();
      } else {
        code = store.getQueryString('code');

        if (!code) {
          getAppid();
        } else {
          auth.value = true;
          getOpenId();
        }
      }
    } else {
      auth.value = false;
    }

    async function getOpenId() {
      await store.getWxOpenId(code);

      if (store.openId) {
        navigateTo();
      }
    }

    function navigateTo() {
      let shareCode = store.getQueryString('shareCode');
      let {
        origin
      } = window.location;

      if (shareCode) {
        router.replace(`/detail?shareCode=${shareCode}`);
      } else {
        if (!store.token) {
          router.replace('/login');
        } else {
          router.replace('/index');
        }
      }
    }

    async function getAppid() {
      const data = await $getAppId();

      if (data) {
        window.location.href = `http://wxauth.yunaibao.xab.vip/get-weixin-code.html?appid=${data}&redirect_uri=${href}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
      }
    }

    return (_ctx, _cache) => {
      const _component_Empty = _resolveComponent("Empty");

      const _component_van_loading = _resolveComponent("van-loading");

      return !_unref(auth) ? (_openBlock(), _createBlock(_component_Empty, {
        key: 0
      }, {
        default: _withCtx(() => [_hoisted_1]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_loading, {
        type: "spinner"
      })]));
    };
  }

};